import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SecurityService } from '../../_infrastructure/Security/SecurityService';
import { SystemInformationService } from '../../_infrastructure/SystemInformation/SystemInformationService';

import { StepDetailsService } from '../../_infrastructure/StepDetailsService/StepDetailsService';
import { Subscription } from 'rxjs';
//import { Dictionary } from 'highcharts';
import { filter } from 'rxjs/operators';
import * as _ from 'lodash';
import { SessionStorageService } from '../../_infrastructure/SessionStorageService/SessionStorageService';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  debug: boolean = false;
  debugUser: string;
  version: string;
  public isExSub: boolean = false;
  public isNSI: boolean = false;
  public domain: string;
  public stepHelperURLs: {
    [key: string]: { code: string, fileRef: string }
  } = Object.create(null);
  public stepDetailsSubscription: Subscription;
  public workflowCode: string = undefined;

  @ViewChild('cgaGetHelpFileForm', { read: ElementRef }) cgaGetHelpFileForm: ElementRef;
  @ViewChild('cgaGetHelpFileFormInput', { read: ElementRef }) cgaGetHelpFileFormInput: ElementRef;

  constructor(private http: HttpClient, public securityService: SecurityService, private systemInformationService: SystemInformationService, private stepDetailsService: StepDetailsService,
    private localStorageService: SessionStorageService, private router: Router) {
    this.stepDetailsSubscription = this.stepDetailsService.needsRevisionSubject.subscribe();
  }

  ngOnInit() {
    this.systemInformationService.loadCurrentSystemInformation().subscribe(result => {
      //this.debugUser = result.debugUser;
      //this.debug = this.debugUser === this.securityService.userDetails.userName;
      this.version = result.version;
      this.domain = this.securityService.userDetails.refererDomain + result.fileTransfer;
      this.isNSI = result.proveniencia == "NSI";
    });


    // Apenas vamos buscar hel~pfiles quando tivermos workflowcode válido
    this.stepDetailsService.workFlowCode.pipe(
      filter(res => {
        if (res !== null && res !== undefined && res.length > 0) {
          return true;
        } else {
          this.isExSub = false;
          return false;
        }
      })
    ).subscribe(res => {
      this.workflowCode = res;
      var tipoPedido = _.cloneDeep(this.workflowCode).replace('PEDI0', 'PGP');
      if (this.workflowCode.indexOf('PEDI005') > -1 || this.workflowCode.indexOf('PEDI008') > -1) this.isExSub = true;
      if (tipoPedido.charAt(tipoPedido.length - 1).match(/[0-9]/) == null) {
        tipoPedido = tipoPedido.slice(0, -1) + 'HS';
      }
      this.http.get('api/Documents/GetStepHelpFiles?workflowCode=' + tipoPedido)
        .subscribe((helpFiles: any) => {
          this.helperURLResolver(helpFiles);
        }
        );
    })

   
  }

  ngOnDestroy(): void {
    this.stepDetailsSubscription.unsubscribe();
    this.stepDetailsService.emitNeedsRevisionChange(false);
    this.stepDetailsService.newCurrentStep(undefined);
  }

  //ngDoCheck(): void {
  //  if (this.stepDetailsService.workFlowCurrentStep !== undefined) {
  //    console.log("current step: ", this.stepDetailsService.workFlowCurrentStep.getValue());
  //  }
  //}

  getUtenteTrimed(): string {
    const regex = / 00$/;
    var utente = this.securityService.userDetails.utente;
    utente = utente.replace(regex, '');
    return utente;
  }

  getVersion(): string {
    return this.version;
  }

  getCurrentStep() {
    return this.stepDetailsService.workFlowCurrentStep.getValue();
  }

  helperURLResolver(stepHelp: any[]) {

    if (this.workflowCode.indexOf("PEDI001") > -1) {
      this.stepHelperURLs["StepSubscriberInfo"] = { code: "PGP01HS01", fileRef: undefined };
      this.stepHelperURLs["StepReb"] = { code: "PGP01HS02", fileRef: undefined };
      this.stepHelperURLs["StepDocuments"] = { code: "PGP01HS03", fileRef: undefined };
      this.stepHelperURLs["StepObs"] = { code: "PGP01HS04", fileRef: undefined };
      this.stepHelperURLs["StepMap"] = { code: "PGP01HS05", fileRef: undefined };
      this.stepHelperURLs["StepRenum"] = { code: "PGP01HS06", fileRef: undefined };
      this.stepHelperURLs["StepSubSituation"] = { code: "PGP01HS07", fileRef: undefined };
      this.stepHelperURLs["CGA01Submit"] = { code: "PGP01HS08", fileRef: undefined };
      this.stepHelperURLs["StepServiceInfo"] = { code: "PGP01HS09", fileRef: undefined };
      this.stepHelperURLs["StepFinalize"] = { code: "PGP01HS10", fileRef: undefined };
      this.stepHelperURLs["StepSubscriberCGA"] = { code: "PGP01HS11", fileRef: undefined };
      this.stepHelperURLs["StepClinicalInfo"] = { code: "PGP01HS12", fileRef: undefined };

    }

    if (this.workflowCode.indexOf("PEDI0020") > -1) {
      this.stepHelperURLs["StepSubscriberInfo"] = { code: "PGP020HS01", fileRef: undefined };
      this.stepHelperURLs["StepReb"] = { code: "PGP01HS02", fileRef: undefined };
      this.stepHelperURLs["StepDocuments"] = { code: "PGP020HS03", fileRef: undefined };
      this.stepHelperURLs["StepObs"] = { code: "PGP020HS04", fileRef: undefined };
      this.stepHelperURLs["StepMap"] = { code: "PGP020HS05", fileRef: undefined };
      this.stepHelperURLs["StepRenum"] = { code: "PGP020HS06", fileRef: undefined };
      this.stepHelperURLs["StepSubSituation"] = { code: "PGP01HS07", fileRef: undefined };
      this.stepHelperURLs["CGA01Submit"] = { code: "PGP020HS08", fileRef: undefined };
      this.stepHelperURLs["StepServiceInfo"] = { code: "PGP020HS09", fileRef: undefined };
      this.stepHelperURLs["StepFinalize"] = { code: "PGP020HS10", fileRef: undefined };
      this.stepHelperURLs["StepSubscriberCGA"] = { code: "PGP020HS11", fileRef: undefined };
      this.stepHelperURLs["StepClinicalInfo"] = { code: "PGP01HS12", fileRef: undefined };
    }

    if (this.workflowCode.indexOf("PEDI008") > -1) {
      this.stepHelperURLs["PEDI008Prestage"] = { code: "PGP08HS01P", fileRef: undefined };
      this.stepHelperURLs["StepSubscriberInfo"] = { code: "PGP08HS01", fileRef: undefined };
      this.stepHelperURLs["StepReb"] = { code: "PGP08HS02", fileRef: undefined };
      this.stepHelperURLs["StepDocuments"] = { code: "PGP08HS03", fileRef: undefined };
      this.stepHelperURLs["StepObs"] = { code: "PGP08HS04", fileRef: undefined };
      this.stepHelperURLs["StepMap"] = { code: "PGP08HS05", fileRef: undefined };
      this.stepHelperURLs["StepRenum"] = { code: "PGP08HS06", fileRef: undefined };
      this.stepHelperURLs["StepSubSituation"] = { code: "PGP08HS07", fileRef: undefined };
      this.stepHelperURLs["CGA01Submit"] = { code: "PGP08HS08", fileRef: undefined };
      this.stepHelperURLs["StepServiceInfo"] = { code: "PGP08HS09", fileRef: undefined };
      this.stepHelperURLs["StepFinalize"] = { code: "PGP08HS10", fileRef: undefined };
      this.stepHelperURLs["StepSubscriberCGA"] = { code: "PGP08HS11", fileRef: undefined };
      this.stepHelperURLs["StepClinicalInfo"] = { code: "PGP08HS12", fileRef: undefined };
    }

    if (this.workflowCode.indexOf("PEDI005") > -1) {
      this.stepHelperURLs["PEDI005Prestage"] = { code: "PGP05HS01P", fileRef: undefined };
      this.stepHelperURLs["StepSubscriberInfo"] = { code: "PGP05HS01", fileRef: undefined };
      this.stepHelperURLs["StepReb"] = { code: "PGP05HS02", fileRef: undefined };
      this.stepHelperURLs["StepDocuments"] = { code: "PGP05HS03", fileRef: undefined };
      this.stepHelperURLs["StepObs"] = { code: "PGP05HS04", fileRef: undefined };
      this.stepHelperURLs["StepMap"] = { code: "PGP05HS05", fileRef: undefined };
      this.stepHelperURLs["StepRenum"] = { code: "PGP05HS06", fileRef: undefined };
      this.stepHelperURLs["StepSubSituation"] = { code: "PGP05HS07", fileRef: undefined };
      this.stepHelperURLs["CGA01Submit"] = { code: "PGP05HS08", fileRef: undefined };
      this.stepHelperURLs["StepServiceInfo"] = { code: "PGP05HS09", fileRef: undefined };
      this.stepHelperURLs["StepFinalize"] = { code: "PGP05HS10", fileRef: undefined };
      this.stepHelperURLs["StepSubscriberCGA"] = { code: "PGP05HS11", fileRef: undefined };
      this.stepHelperURLs["StepClinicalInfo"] = { code: "PGP05HS12", fileRef: undefined };
    }

    if (this.workflowCode == 'PEDI002' || this.workflowCode == 'PEDI002A' || this.workflowCode == 'PEDI002B') {
      this.stepHelperURLs["PEDI002Prestage"] = { code: "PGP02HS01P", fileRef: undefined };
      this.stepHelperURLs["StepSender"] = { code: "PGP02HS01", fileRef: undefined };
      this.stepHelperURLs["StepDeceased"] = { code: "PGP02HS02", fileRef: undefined };
      this.stepHelperURLs["StepBeneficiary"] = { code: "PGP02HS03", fileRef: undefined };
      this.stepHelperURLs["StepDocumentsPM"] = { code: "PGP02HS04", fileRef: undefined };
      this.stepHelperURLs["StepFinalizePM"] = { code: "PGP02HS05", fileRef: undefined };
    }

    for (let i = 0; i < stepHelp.length; i++) {
      let j: keyof { [key: string]: { code: string, fileRef: string } }
      for (j in this.stepHelperURLs) {
        if (stepHelp[i]['codigo'] === this.stepHelperURLs[j]['code']) {
          if (this.stepHelperURLs[j].hasOwnProperty("fileRef")) {
            this.stepHelperURLs[j].fileRef = parseInt(stepHelp[i].refFichID).toString();
          }
        }
      }
    }
 


  }

  public getHelpFile() {
    let currentStep = this.getCurrentStep();
    if (this.isExSub && (currentStep == null || currentStep == undefined)) currentStep = this.workflowCode + 'Prestage';
    var fileURL = this.stepHelperURLs[currentStep]['fileRef'];
    this.cgaGetHelpFileFormInput.nativeElement.value = fileURL;
    this.cgaGetHelpFileForm.nativeElement.action = this.domain;

    this.cgaGetHelpFileForm.nativeElement.submit();
    return false;
  }

  // PIT 40803 \\
  public limparFiltro() {
    this.localStorageService.removeListaDePedidosOption();
  }

  public isHelpVisible(): boolean {
    let result = false;
    const subscritorMode = !this.isExSub && this.getCurrentStep() !== undefined && (this.workflowCode !== undefined && this.workflowCode !== null);
    const exSubscritorMode = this.isExSub && (this.workflowCode !== undefined && this.workflowCode !== null);
    //const subscritorPM = this.isExSub && (this.workflowCode !== undefined && this.workflowCode !== null);
    result = subscritorMode || exSubscritorMode;
    return result;
  }
}
